<div class="p-4 min-w-[300px] bg-white rounded-lg shadow-lg">
  <!-- Textarea -->
  <div class="mb-4">
    <label for="note-textarea" class="text-lg font-bold mb-1 uppercase">FACTURA - {{data.serials}}</label>
    <textarea 
      id="note-textarea"
      [(ngModel)]="noteContent"
      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 mt-4"
      rows="5"
      placeholder="Escribe tu nota aquí..."></textarea>
  </div>

  <!-- Botones -->
  <div class="flex justify-end space-x-2">
    <button mat-button (click)="onCancel()" class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSave()">
      Guardar
    </button>
  </div>
</div>